import React, {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate, useLocation} from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {Alert, Snackbar, Grid, TextField, Card, AppBar, Typography} from "@mui/material";
import MDButton from "components/MDButton";
import {POST} from "APIclient";
import {LocalizationProvider, DatePicker} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {DataGrid} from "@mui/x-data-grid";
import {GET} from "APIclient";
import properties from "constants/ApplicationConstants";

const formatDate = date => {
  const parsedDate = new Date(date);
  if (!isNaN(parsedDate)) {
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric"
    }).format(parsedDate);
  }
  return "";
};

const columns = [
  {
    field: "startDate",
    headerName: "Start Date",
    width: 200,
    headerAlign: "center",
    align: "center",
    renderCell: params => formatDate(params.value)
  },
  {
    field: "endDate",
    headerName: "End Date",
    width: 200,
    headerAlign: "center",
    align: "center",
    renderCell: params => formatDate(params.value)
  },
  {
    field: "reportingTo",
    headerName: "Reporting To",
    width: 200,
    headerAlign: "center",
    align: "center"
  },
  {
    field: "addedOn",
    headerName: "Issued On",
    width: 200,
    headerAlign: "center",
    align: "center",
    renderCell: params => formatDate(params.value)
  }
];

function ReportingHistory() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const employee = location.state || {};

  const [open, setOpen] = useState(false);
  const [snakColor, setSnakColor] = useState("");
  const [snakMessage, setSnakMessage] = useState("");
  const handleClose = () => setOpen(false);

  const [reportingData, setReportingData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReportingData = async () => {
      try {
        const url = `admin/employee/reporting/${employee.empId}`;
        const response = await GET(url);
        if (response?.status === 200) {
          const data = response?.data?.data?.paginatedData;
          setReportingData(data);
          setLoading(false);
        } else if (response?.status === 204) {
          setReportingData([]);
          setSnakColor("info");
          setSnakMessage("No reporting history found");
          setOpen(true);
          setLoading(false);
        } else {
          setSnakColor("error");
          setSnakMessage("Failed to fetch reporting history");
          setOpen(true);
        }
      } catch (error) {
        console.error("Error fetching reporting data:", error);
        setSnakColor("error");
        setSnakMessage("Error fetching reporting history");
        setOpen(true);
      }
    };
    fetchReportingData();
  }, [employee.empId]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <MDBox container sx={{minHeight: "100vh", width: "98%"}}>
          <AppBar position="static">
            <Card>
              <MDBox
                pt={2}
                mb={0}
                pb={4}
                px={4}
                sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
              >
                <Typography
                  sx={{fontSize: "16px", fontWeight: "600", fontFamily: properties.fontFamily}}
                  color="textPrimary"
                >
                  {" "}
                  General Details
                </Typography>
                <MDBox display="flex" flexDirection="column" pt={2}>
                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{
                          fontSize: "14px",
                          fontWeight: "600",
                          fontFamily: properties.fontFamily,
                          minWidth: "150px"
                        }}
                      >
                        Employee Name:
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        sx={{
                          fontSize: "14px",
                          fontWeight: "500",
                          fontFamily: properties.fontFamily
                        }}
                      >
                        {employee.employeeName || "-"}
                      </MDTypography>
                    </Grid>

                    <Grid item xs={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{
                          fontSize: "14px",
                          fontWeight: "600",
                          fontFamily: properties.fontFamily,
                          minWidth: "150px"
                        }}
                      >
                        Joining Date :
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {formatDate(employee.joinDate) || "-"}
                      </MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            </Card>
          </AppBar>

          <MDBox mt={3}>
            <MDTypography
              variant="h6"
              sx={{
                fontWeight: "600",
                fontFamily: properties.fontFamily,
                marginBottom: "20px",
                color: "black"
              }}
            >
              Reporting History
            </MDTypography>
            <DataGrid
              rows={reportingData}
              columns={columns}
              loading={loading}
              getRowId={row => row.leaveRequestId}
              sx={{
                fontFamily: properties.fontFamily,
                fontSize: "14px",
                fontWeight: 400,
                "& .MuiDataGrid-scrollbar": {
                  width: "10px !important"
                }
              }}
            />
          </MDBox>

          <Snackbar
            open={open}
            anchorOrigin={{vertical: "top", horizontal: "right"}}
            autoHideDuration={2000}
            onClose={handleClose}
          >
            <Alert onClose={handleClose} severity={snakColor} variant="filled">
              {snakMessage}
            </Alert>
          </Snackbar>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default ReportingHistory;
